import { linkMapping } from './linkMapping';

export const getOptions = (links) => {
  const filterOptions = {
    campaign: [],
    channel: [],
    medium: [],
    source: [],
    marketer: [],
  };
  const fields = Object.entries(linkMapping);
  links.forEach((link) => {
    fields.forEach(([field, linkValue]) => {
      const newValue = linkValue(link);
      if (!newValue) {
        return;
      }
      const exists = filterOptions[field].find(
        ({ value }) => value === newValue
      );
      if (exists) {
        return;
      }
      filterOptions[field].push({
        value: newValue,
        label: newValue,
        id: `${field}-${filterOptions[field].length}`,
      });
    });
  });
  return filterOptions;
};
